import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	ctaTitle: MessageDescriptor;
	ctaDescription: MessageDescriptor;
	ctaLink: MessageDescriptor;
	whyAmISeeingThisReason: MessageDescriptor;
} = defineMessages({
	ctaTitle: {
		id: 'jira-twg-cli-cta.cta-title',
		defaultMessage: 'Give agents more context',
		description: 'CTA title for the Jira TWG CLI CTA',
	},
	ctaDescription: {
		id: 'jira-twg-cli-cta.cta-description',
		defaultMessage:
			"Ground agents in your org's work. Get 44% better answers with 48% fewer tokens.",
		description: 'CTA description for the Jira TWG CLI CTA',
	},
	ctaLink: {
		id: 'jira-twg-cli-cta.cta-link',
		defaultMessage: 'Learn More',
		description: 'CTA link text for the Jira TWG CLI CTA',
	},
	whyAmISeeingThisReason: {
		id: 'jira-twg-cli-cta.why-am-i-seeing-this-reason',
		defaultMessage: 'You have indicated interest in using coding agents',
		description: 'Reason for why the user is seeing the Jira TWG CLI CTA',
	},
});
